import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'join', standalone: false})
export class JoinPipe implements PipeTransform {
  transform <T> (value: T[], delimiter: string = ', ', joinByProperty?: keyof T): string {
    const valuesToJoin = joinByProperty ? value.map(item => item[joinByProperty]) : value;
    return valuesToJoin.join(delimiter);
  }
}
